import { useState } from 'react'

export const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState('')
  const [copied, setCopied] = useState(false)

  const copyToClipboard = (text: string, timeout?: number) => {
    try {
      navigator?.clipboard?.writeText(text)
      setCopiedText(text)
      setCopied(true)
      if (timeout) {
        setTimeout(() => {
          setCopied(false)
        }, timeout)
      }
    } catch (error) {
      console.error('Failed to copy text to clipboard:', error)
    }
  }

  return { copiedText, copied, copyToClipboard }
}
